import { useAppSelector } from '../../Reducers/store';
import { useEffect, useState } from 'react';
import { UserLevelNames } from '../../Models/UserLevel';
import { Button, Tooltip } from 'flowbite-react';
import { HiOutlinePlus } from 'react-icons/hi';
import SitePagesList from './SitePagesList';
import Loader from '../Common/Loader';
import EditSitePage from './EditSitePage';
import SitePageApi from '../../Api/SitePageApi';
import CommonApi from '../../Api/CommonApi';
import { toast } from 'react-toastify';
import CopySitePageModal from './CopySitePageModal';
import { SitePageListDto } from '../../Models/SitePageListDto';

export default function MemberSitePages() {
  const { userModel } = useAppSelector((state) => state.user);
  const [showAddEditSitePage, setShowAddEditSitePage] =
    useState<boolean>(false);
  const [selectedSitePage, setSelectedSitePage] = useState<number | null>(null);

  const [pagesData, setPagesData] = useState<SitePageListDto[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [pageToCopy, setPageToCopy] = useState<SitePageListDto | null>(null);
  const [isCopying, setIsCopying] = useState(false);

  useEffect(() => {
    checkAccess();
  }, []);

  useEffect(() => {
    if (!showAddEditSitePage) getSitePages();
  }, [showAddEditSitePage]);

  const getSitePages = () => {
    try {
      setIsLoading(true);
      return SitePageApi.getSitePageList()
        .then((res) => {
          setPagesData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {});
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  function checkAccess() {
    if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
      return true;
    } else {
      return false;
    }
  }

  const handleAddSitePageClick = () => {
    setShowAddEditSitePage(true);
  };

  const handleCopyPageClick = (row: SitePageListDto) => {
    setPageToCopy(row);
    setShowCopyModal(true);
  };

  const handleCopyPageConfirm = async () => {
    if (!pageToCopy) return;
    setIsCopying(true);
    try {
      const res = await SitePageApi.copySitePage(pageToCopy.id);
      if (res.data.success) {
        const newId = parseInt(res.data.affectedEntityIdentifier ?? "0", 10);
        toast.success(res.data.message ?? "Page copied");
        setShowCopyModal(false);
        setPageToCopy(null);
        await getSitePages();
        if (newId > 0) {
          setSelectedSitePage(newId);
          setShowAddEditSitePage(true);
        }
      } else {
        toast.error(res.data.message ?? "Failed to copy page");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to copy page");
    } finally {
      setIsCopying(false);
    }
  };

  const deleteFile = (id: number) => {
    CommonApi.deleteSitePage(id)
      .then((res) => {
        if (res.data.success) {
          getSitePages();
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Failed to delete file');
      });
  };

  return (
    <>
      {checkAccess() && (
        <div className='float-right pr-6'>
          {userModel && userModel.userLevelId === UserLevelNames.SuperAdmin && (
            <Tooltip content='Add File'>
              <Button onClick={handleAddSitePageClick} className='buttonMain'>
                <HiOutlinePlus />
              </Button>{' '}
            </Tooltip>
          )}
        </div>
      )}
      <div className='w-full'>
        <div className='w-full p-4'>
          {isLoading && <Loader />}
          <SitePagesList
            data={pagesData}
            setSelectedSitePage={setSelectedSitePage}
            setShowSitePage={setShowAddEditSitePage}
            accessCheck={checkAccess()}
            deleteFile={deleteFile}
            onCopyPage={handleCopyPageClick}
          />
        </div>
      </div>
      <EditSitePage
        selectedSitePage={selectedSitePage}
        show={showAddEditSitePage}
        setShow={setShowAddEditSitePage}
        setSelectedSitePage={setSelectedSitePage}
      />
      <CopySitePageModal
        show={showCopyModal}
        page={
          pageToCopy
            ? {
                id: pageToCopy.id,
                title: pageToCopy.title,
                header: pageToCopy.title,
                pageTypeId: null,
                description: null,
                metaData: null,
                enbedCode: null,
                iframeHeight: null,
                iframeWidth: null,
                pageType: null,
              }
            : null
        }
        isCopying={isCopying}
        onClose={() => {
          setShowCopyModal(false);
          setPageToCopy(null);
        }}
        onConfirm={handleCopyPageConfirm}
      />
    </>
  );
}
